import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { isValid, parseISO, isAfter } from 'date-fns';

export function dateRangeValidator(
  startKey: string,
  endKey: string,
  errorKey: string
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startValue = group.get(startKey)?.value;
    const endValue = group.get(endKey)?.value;

    if (!startValue || !endValue) return null;

    // Transforma em Date usando parseISO se vier string ISO
    const startDate =
      typeof startValue === 'string'
        ? parseISO(startValue)
        : new Date(startValue);
    const endDate =
      typeof endValue === 'string' ? parseISO(endValue) : new Date(endValue);

    if (!isValid(startDate) || !isValid(endDate)) return null;

    // Valida se a data de início NÃO é antes da de fim
    if (!isAfter(endDate, startDate)) {
      return { [errorKey]: true };
    }

    return null;
  };
}
export function conditionalCoverageValidator(
  financialParamCoverage: AbstractControl
) {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const financialCoverage = financialParamCoverage?.value;
    if (
      financialCoverage === 'Parcial' &&
      (control.value === null || control.value === '')
    ) {
      return { required: true };
    }
    return null;
  };
}

export function formatDateToISO(date: Date | string): string {
  return new Date(date).toISOString(); // retorna no formato: 2025-04-24T23:26:31.463Z
}

export function idadeMinimaValidator(minIdade: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dataNascimento = new Date(control.value);
    const hoje = new Date();
    let idade = hoje.getFullYear() - dataNascimento.getFullYear();
    const diferencaMeses = hoje.getMonth() - dataNascimento.getMonth();

    if (
      diferencaMeses < 0 ||
      (diferencaMeses === 0 && hoje.getDate() < dataNascimento.getDate())
    ) {
      idade--;
    }

    return idade >= minIdade
      ? null
      : { idadeMinima: { value: control.value, minIdade } };
  };
}

export function duracaoAnosMaxValidator(
  group: AbstractControl
): ValidationErrors | null {
  const duracaoAnos = group.get('duracaoAnos')?.value;
  const quantidadeAnosCurricular = group.get('quantidadeAnosCurricular')?.value;

  if ((duracaoAnos > 6 || quantidadeAnosCurricular > 6) && duracaoAnos !== 0) {
    return { duracaoExcedida: true };
  }
  return null;
}

export function formatPhoneNumber(
  phone: string | undefined
): string | undefined {
  if (!phone) return undefined; // Retorna undefined se o valor for inválido

  // Remove todos os espaços em branco
  let formattedPhone = phone.replace(/\s+/g, '');

  // Adiciona o código do país +244 caso ele não exista
  if (!formattedPhone.startsWith('+244')) {
    formattedPhone = `+244${formattedPhone}`;
  }

  // Valida se o número é composto apenas por caracteres válidos (apenas números e o prefixo +244)
  // if (!/^\+244\d+$/.test(formattedPhone)) {
  //   throw new Error(`Número de telefone inválido: ${phone}`);
  // }

  return formattedPhone;
}

export function parseDate(dateStr: string): Date {
  const [day, month, year] = dateStr.split('/').map(Number);
  return new Date(year, month - 1, day); // O mês em Date começa do índice 0
}
